import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import ZiggeoMediaRecorder from '../ZiggeoVideo/ZiggeoMediaRecorder';
import HippoMediaRecorder from '../HippoVideo/HippoMediaRecorder';

const Recorder = props => {
  const {
    allowDragAndDrop,
    allowScreen,
    allowUpload,
    allowWebcam,
    apiKey,
    webcamPlaybackEnabled,
    multiStreamEnabled,
    saveMedia,
    disabled,
    mediaLocales,
    onRecording,
    onRecordingStopped,
    onUploading,
    provider,
    recordWebcamEvent,
    setUploadStarted,
    setUploadingComplete,
    handleBadUploadType,
    elementId,
    questionId,
    progressId,
    trackEvents,
    events,
    onBrowserRecordingNotSupported: onBrowserRecordingNotSupportedProp,
    currentUserId,
    wide,
    id,
  } = props;

  const onBrowserRecordingNotSupported = () => {};

  const recordingProvider = provider || 'ziggeo';

  if (recordingProvider === 'hippo_video') {
    return (
      <HippoMediaRecorder
        allowDragAndDrop={allowDragAndDrop}
        isScreenRecording={allowScreen}
        allowUpload={allowUpload}
        allowWebcam={allowWebcam}
        apiKey={apiKey}
        webcamPlaybackEnabled={webcamPlaybackEnabled}
        multiStreamEnabled={multiStreamEnabled}
        saveMedia={saveMedia}
        mediaLocales={mediaLocales}
        onRecording={onRecording}
        onRecordingStopped={onRecordingStopped}
        onUploading={onUploading}
        recordWebcamEvent={recordWebcamEvent}
        setUploadStarted={setUploadStarted}
        disabled={disabled}
        setUploadingComplete={setUploadingComplete}
        handleBadUploadType={handleBadUploadType}
        trackEvents={trackEvents}
        progressId={progressId}
        questionId={questionId}
        elementId={elementId}
        events={events}
        onBrowserRecordingNotSupported={
          onBrowserRecordingNotSupportedProp || onBrowserRecordingNotSupported
        }
        currentUserId={currentUserId}
        wide={wide}
      />
    );
  }
  return (
    <div className={cn({ 'VideoEmbed--disabled': disabled })}>
      <ZiggeoMediaRecorder
        id={id || ''}
        isScreenRecording={allowScreen}
        allowUpload={allowUpload}
        allowWebcam={allowWebcam}
        apiKey={apiKey}
        webcamPlaybackEnabled={webcamPlaybackEnabled}
        multiStreamEnabled={multiStreamEnabled}
        saveMedia={saveMedia}
        mediaLocales={mediaLocales}
        onRecording={onRecording}
        onUploading={onUploading}
        recordWebcamEvent={recordWebcamEvent}
        setUploadStarted={setUploadStarted}
        setUploadingComplete={setUploadingComplete}
        handleBadUploadType={handleBadUploadType}
        onBrowserRecordingNotSupported={
          onBrowserRecordingNotSupportedProp || onBrowserRecordingNotSupported
        }
      />
    </div>
  );
};

Recorder.propTypes = {
  i18n: PropTypes.shape({}),
  saveMedia: PropTypes.func,
  apiKey: PropTypes.string,
  webcamPlaybackEnabled: PropTypes.bool,
  recordWebcamEvent: PropTypes.func,
  setUploadStarted: PropTypes.func,
  handleBadUploadType: PropTypes.func,
  allowScreen: PropTypes.bool,
  allowUpload: PropTypes.bool,
  allowWebcam: PropTypes.bool,
  multiStreamEnabled: PropTypes.bool,
  mediaLocales: PropTypes.arrayOf(
    PropTypes.shape({
      priority: PropTypes.number,
    }),
  ),
  onRecording: PropTypes.func,
  onUploading: PropTypes.func,
  setUploadingComplete: PropTypes.func,
};

export default Recorder;
